<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <h1>メールアドレス認証</h1>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Authentication',
  mounted: function () {
    let api = new ApiService();
    api.authentication(this.$route.params.token)
      .then((response) => {
        this.$swal('認証完了', "メールアドレスの認証が完了しました。このあとスタッフによるユーザーの確認を行いますので、今暫くお待ち下さい。", 'info')
          .then(() => {
            this.$router.push({path: "/app/color/login"});
          });
      })
      .catch((error) => {
        this.$swal('エラー', "認証が行えませんでした、解決しない場合はサポートチームへお問い合わせください。", 'error');
      });
  }
}
</script>
